import {
  GetTokenOptions,
  ILogProvider,
} from '@sennder/senn-node-microfrontend-interfaces'
import {
  RouteLocationNormalized,
  RouteLocationResolved,
  RouteRecordName,
} from 'vue-router'

export const wrapAuthWithLogging = (
  func: (options?: GetTokenOptions) => Promise<string | null>,
  logger: ILogProvider
) => {
  const wrappedFunction: (
    options?: GetTokenOptions
  ) => Promise<string | null> = async (...args) => {
    logger.info('[Legacy Auth Attempt]', {
      args,
    })
    return await func(...args)
  }

  return wrappedFunction
}

export const whenIdle = (callback: () => void, timeout = 1000) => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(callback, { timeout })
  } else {
    setTimeout(callback, 1)
  }
}

/**
 * This helper takes a route and tries to find the most specific name for it. It first checks if the route itself has a name, then it checks the matched routes from the router and returns the name of the most specific one. If no name is found, it returns null.
 * Use this function to match routes to their micro-frontend's configuration, which may be based on route names. This is especially useful for nested routes, where the parent route may have a name while the child routes do not.
 *
 * @param route current location from the router
 * @returns route name if available, otherwise null.
 */
export const getRouteLocationName = (
  route: RouteLocationNormalized | RouteLocationResolved
): RouteRecordName | null => {
  return route.name ?? route.matched.find((r) => r.name)?.name ?? null
}
